import React from 'react';
import { IPermissionsListProps } from './PermissionsList.types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { IPermissionDetail } from '../../../services/rolesAndPermissions/rolesAndPermissions.types';
import { useStyles } from './PermissionsList.styles';
import { NoRecords } from '../../NoRecords/NoRecords.component';
import TooltipOne from '../../TooltipOne/TooltipOne.component';
import SwitchOne from '../../SwitchOne/SwitchOne.component';

export const PermissionsList: React.FC<IPermissionsListProps> = ({
  permissions,
  onTogglePermissionActivity,
  withSearchResults,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.scrollBox}>
      {permissions.length ? (
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {permissions.map((permission: IPermissionDetail) => {
            return (
              <ListItem key={permission.id} className={classes.listItem} disablePadding={true}>
                <ListItemText
                  primary={
                    <>
                      <div>{permission.id}</div>
                      <div>{permission.name}</div>
                    </>
                  }
                />
                <TooltipOne title={"Uprawnienie: " + permission.name + " jest teraz " + (permission.isActive ? "włączone" : "wyłączone")} placement="top">
                  <span>
                    <SwitchOne
                      disableRipple
                      checked={permission.isActive}
                      color={'primary'}
                      onChange={() => onTogglePermissionActivity(permission.id)}
                      inputProps={{ 'aria-label': `Zmień aktywność uprawnienia "${permission.name}"` }}
                      />
                    </span>
                  </TooltipOne>
              </ListItem>
            );
          })}
        </List>
      ) : withSearchResults ? (
        <NoRecords withMargin="150px" />
      ) : (
        <div className={classes.emptyMessage}>Brak rekordów do wyświetlenia</div>
      )}
    </div>
  );
};
